import React, { useState } from "react";

const esc = (s) => String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

// Minimal, dependency-free markdown → HTML (input is escaped first, so only our own tags are emitted).
export function mdToHtml(src = "") {
  let s = esc(src);
  s = s.replace(/```([\s\S]*?)```/g, (_, c) => `<pre class="md-pre">${c.trim()}</pre>`);
  s = s.replace(/`([^`\n]+)`/g, '<code class="md-code">$1</code>');
  s = s.replace(/^### (.*)$/gm, "<h3>$1</h3>").replace(/^## (.*)$/gm, "<h2>$1</h2>").replace(/^# (.*)$/gm, "<h1>$1</h1>");
  s = s.replace(/\*\*(.+?)\*\*/g, "<b>$1</b>").replace(/(^|[^*\w])\*([^*\n]+)\*/g, "$1<i>$2</i>");
  s = s.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
  s = s.replace(/(^|\n)((?:[-*] .*(?:\n|$))+)/g, (_, p, b) => `${p}<ul>${b.trim().split("\n").map((l) => `<li>${l.replace(/^[-*] /, "")}</li>`).join("")}</ul>\n`);
  s = s.replace(/(^|\n)((?:\d+\. .*(?:\n|$))+)/g, (_, p, b) => `${p}<ol>${b.trim().split("\n").map((l) => `<li>${l.replace(/^\d+\. /, "")}</li>`).join("")}</ol>\n`);
  return s.split(/\n{2,}/).map((b) => { const t = b.trim(); if (!t) return ""; return /^<(h\d|ul|ol|pre)/.test(t) ? t : `<p>${t.replace(/\n/g, "<br/>")}</p>`; }).join("");
}

export function Markdown({ text, className = "", testid }) {
  return <div className={`md ${className}`} data-testid={testid} dangerouslySetInnerHTML={{ __html: mdToHtml(text || "") }} />;
}

export function MarkdownEditor({ value, onChange, placeholder, rows = 6, disabled, testid = "md-editor" }) {
  const [tab, setTab] = useState("write");
  return (
    <div className="overflow-hidden rounded-xl border border-line bg-white" data-testid={testid}>
      <div className="flex items-center gap-1 border-b border-line bg-slate-50 px-2 py-1">
        {[["write", "Tulis"], ["preview", "Pratinjau"]].map(([k, l]) => <button type="button" key={k} onClick={() => setTab(k)} data-testid={`${testid}-tab-${k}`} className={`rounded-lg px-2.5 py-1 text-xs font-bold transition-colors ${tab === k ? "bg-white text-slate-900 shadow-sm" : "text-slate-500 hover:text-slate-800"}`}>{l}</button>)}
        <span className="ml-auto text-[10px] text-slate-400">Markdown: **tebal** · *miring* · `kode` · - daftar · [tautan](https://…)</span>
      </div>
      {tab === "write"
        ? <textarea value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} rows={rows} disabled={disabled} data-testid={`${testid}-input`} className="block w-full resize-y bg-transparent px-3 py-2.5 text-sm text-slate-900 outline-none placeholder:text-slate-400" />
        : <div className="min-h-[120px] px-3 py-2.5 text-sm">{value?.trim() ? <Markdown text={value} testid={`${testid}-preview`} /> : <p className="text-slate-400">Belum ada isi untuk dipratinjau.</p>}</div>}
    </div>
  );
}
